// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fc-toolbar.fc-header-toolbar {
  margin-bottom: 0;
  position: relative;
  height: 50px;
  width: 100%;
}

@media (min-width: 800px) {
  .fc-toolbar.fc-header-toolbar {
    min-height: 50px;
    height: auto;
    width: auto;
  }
}

.fc-row.fc-widget-header {
  border-bottom: 1px solid #dddddd;
}

.fc-save-button {
  display: none;
}

@media (min-width: 800px) {
  .fc-save-button {
    display: block;
  }
}

.fc-save-button,
.fc-save-button.fc-button-primary,
.fc-save-button.fc-button:hover,
.fc-save-button.fc-button:focus,
.fc-save-button.fc-button:active,
.fc-save-button.fc-button.fc-button-primary:disabled,
.fc-save-button.fc-button-primary:not(:disabled):active,
.fc-save-button.fc-button-primary:not(:disabled).fc-button-active,
.fc-save-button.fc-button-primary:not(:disabled):active:focus,
.fc-save-button.fc-button-primary:not(:disabled).fc-button-active:focus {
  background-color: var(--pri-03);
  padding: 5px 30px;
  color: var(--pri-01);
  font-family: var(--font-semibold);
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  min-width: 100px;
  height: 45px;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: border 120ms ease-in,
              border-color 120ms ease-in,
              color 120ms ease-in;
  border-radius: 7px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.fc-save-button.fc-button.fc-button-primary:disabled {
  background-color: var(--gray-l);
  cursor: not-allowed;
}

/* old styles below */

.fc-time-grid-event .fc-title {
  font-size: 12px;
  word-break: break-word;
}

.fc-time-grid-event .fc-time {
  font-size: 12px;
}

.fc-highlight {
  background-color: #E4ECF4;
}

.fc-bgevent {
  background: none;
}

.fc-unthemed td.fc-today {
  background-color: #fff;
}

.fc-time-grid .fc-slats .fc-minor .fc-axis.fc-time.fc-widget-content {
  border-top-color: transparent;
}

.fc-axis.fc-time.fc-widget-content {
  color: var(--gray-d);
}

.fc-day-header.fc-widget-header {
  font-family: var(--font-semibold);
  font-size: 16px;
}

.fc-day-header.fc-widget-header.fc-disabled-day {
  background: #fff;
  opacity: 1;
}

.fc-unthemed .fc-disabled-day {
  background: #ccc;
  opacity: 0.3;
}

.fc-toolbar.fc-header-toolbar {
  font-family: var(--font-bold);
}

.fc-button,
.fc-button-primary:disabled {
  background-color: transparent;
  border: none;
}

.fc-button-primary:disabled:hover {
  cursor: not-allowed;
}

.fc-button-primary:disabled .fc-icon {
  color: var(--gray-l);
  cursor: not-allowed;
}

.fc-toolbar.fc-header-toolbar .fc-center h2 {
  font-size: 14px;
}

.fc-button:hover,
.fc-button:focus,
.fc-button:active,
.fc-button-primary:not(:disabled):active,
.fc-button-primary:not(:disabled).fc-button-active,
.fc-button-primary:not(:disabled):active:focus,
.fc-button-primary:not(:disabled).fc-button-active:focus {
  cursor: default;
  background-color: transparent;
  box-shadow: none;
  border: none;
}

.fc-button-primary .fc-icon-chevron-left,
.fc-button-primary .fc-icon-chevron-right {
  cursor: pointer;
  color: var(--gray-d);
  border-radius: 50%;
  font-size: 38px;
}

.fc-ltr .fc-time-grid .fc-event-container {
  margin: 0 3px;
}

.fc-unselectable.fc-not-allowed {
  cursor: default;
}

.fc-now-indicator {
  border: 0 solid var(--pri-04);
}

@media (min-width: 800px) {
  .fc-toolbar.fc-header-toolbar .fc-center h2 {
    font-size: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/static/css/useable/full-calendar.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;;;;;;;;;EAUE,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB;;iCAE+B;EAC/B,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,qBAAqB;;AAErB;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;EAOE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".fc-toolbar.fc-header-toolbar {\n  margin-bottom: 0;\n  position: relative;\n  height: 50px;\n  width: 100%;\n}\n\n@media (min-width: 800px) {\n  .fc-toolbar.fc-header-toolbar {\n    min-height: 50px;\n    height: auto;\n    width: auto;\n  }\n}\n\n.fc-row.fc-widget-header {\n  border-bottom: 1px solid #dddddd;\n}\n\n.fc-save-button {\n  display: none;\n}\n\n@media (min-width: 800px) {\n  .fc-save-button {\n    display: block;\n  }\n}\n\n.fc-save-button,\n.fc-save-button.fc-button-primary,\n.fc-save-button.fc-button:hover,\n.fc-save-button.fc-button:focus,\n.fc-save-button.fc-button:active,\n.fc-save-button.fc-button.fc-button-primary:disabled,\n.fc-save-button.fc-button-primary:not(:disabled):active,\n.fc-save-button.fc-button-primary:not(:disabled).fc-button-active,\n.fc-save-button.fc-button-primary:not(:disabled):active:focus,\n.fc-save-button.fc-button-primary:not(:disabled).fc-button-active:focus {\n  background-color: var(--pri-03);\n  padding: 5px 30px;\n  color: var(--pri-01);\n  font-family: var(--font-semibold);\n  font-size: 16px;\n  text-align: center;\n  cursor: pointer;\n  min-width: 100px;\n  height: 45px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  transition: border 120ms ease-in,\n              border-color 120ms ease-in,\n              color 120ms ease-in;\n  border-radius: 7px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\n.fc-save-button.fc-button.fc-button-primary:disabled {\n  background-color: var(--gray-l);\n  cursor: not-allowed;\n}\n\n/* old styles below */\n\n.fc-time-grid-event .fc-title {\n  font-size: 12px;\n  word-break: break-word;\n}\n\n.fc-time-grid-event .fc-time {\n  font-size: 12px;\n}\n\n.fc-highlight {\n  background-color: #E4ECF4;\n}\n\n.fc-bgevent {\n  background: none;\n}\n\n.fc-unthemed td.fc-today {\n  background-color: #fff;\n}\n\n.fc-time-grid .fc-slats .fc-minor .fc-axis.fc-time.fc-widget-content {\n  border-top-color: transparent;\n}\n\n.fc-axis.fc-time.fc-widget-content {\n  color: var(--gray-d);\n}\n\n.fc-day-header.fc-widget-header {\n  font-family: var(--font-semibold);\n  font-size: 16px;\n}\n\n.fc-day-header.fc-widget-header.fc-disabled-day {\n  background: #fff;\n  opacity: 1;\n}\n\n.fc-unthemed .fc-disabled-day {\n  background: #ccc;\n  opacity: 0.3;\n}\n\n.fc-toolbar.fc-header-toolbar {\n  font-family: var(--font-bold);\n}\n\n.fc-button,\n.fc-button-primary:disabled {\n  background-color: transparent;\n  border: none;\n}\n\n.fc-button-primary:disabled:hover {\n  cursor: not-allowed;\n}\n\n.fc-button-primary:disabled .fc-icon {\n  color: var(--gray-l);\n  cursor: not-allowed;\n}\n\n.fc-toolbar.fc-header-toolbar .fc-center h2 {\n  font-size: 14px;\n}\n\n.fc-button:hover,\n.fc-button:focus,\n.fc-button:active,\n.fc-button-primary:not(:disabled):active,\n.fc-button-primary:not(:disabled).fc-button-active,\n.fc-button-primary:not(:disabled):active:focus,\n.fc-button-primary:not(:disabled).fc-button-active:focus {\n  cursor: default;\n  background-color: transparent;\n  box-shadow: none;\n  border: none;\n}\n\n.fc-button-primary .fc-icon-chevron-left,\n.fc-button-primary .fc-icon-chevron-right {\n  cursor: pointer;\n  color: var(--gray-d);\n  border-radius: 50%;\n  font-size: 38px;\n}\n\n.fc-ltr .fc-time-grid .fc-event-container {\n  margin: 0 3px;\n}\n\n.fc-unselectable.fc-not-allowed {\n  cursor: default;\n}\n\n.fc-now-indicator {\n  border: 0 solid var(--pri-04);\n}\n\n@media (min-width: 800px) {\n  .fc-toolbar.fc-header-toolbar .fc-center h2 {\n    font-size: 24px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
